import type { RouteRecordRaw } from 'vue-router'

const tenantRoutes: RouteRecordRaw[] = [
  {
    path: '/tenant',
    component: () => import('@/views/app/the-layout.vue'),
    children: [
      {
        path: '',
        name: 'tenant list',
        component: () => import('@/views/app/tenant/list/page-list.vue'),
        meta: { title: 'Tenant' },
      },
      {
        path: ':id/pengguna',
        name: 'tenant detail',
        props: true,
        component: () => import('@/views/app/tenant/detail/page-detail.vue'),
        meta: { title: 'Tenant Detail' },
      },
    ],
  },
]

export default tenantRoutes

